// styles/base/components/cards.js
/**
 * Card variants for metrics and sophisticated data presentation
 * Because content deserves containers worthy of its importance
 */

import { panelHeaderSx, panelTileSx } from '../panels';

export const cardContentOverrides = {
    styleOverrides: {
        root: {
            '&:last-child': {
                paddingBottom: 0,
            },
        },
    },
};

export const cardVariants = {
    variants: [
        {
            props: { variant: 'metricCard' },
            style: {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                ...panelTileSx,
                borderRadius: '4px',
            },
        },
        {
            props: { variant: 'chartCard' },
            style: {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '4px',
            },
        },
    ],
};

/**
 * Card header variants for consistent chart presentation
 * Professional headers that command attention without ostentation
 */
export const cardHeaderVariants = {
    variants: [
        {
            props: { variant: 'chartHeader' },
            style: {
                ...panelHeaderSx,
                padding: '10px 12px',
                height: '42px',
                '& .MuiTypography-root': {
                    fontWeight: 'bold',
                    fontSize: '1rem',
                },
                '& .MuiCardHeader-action': {
                    margin: 0,
                    alignSelf: 'center',
                },
                '@media (max-width: 1400px)': {
                    padding: '6px 10px',
                    height: '36px',
                    '& .MuiTypography-root': {
                        fontSize: '0.85rem',
                    },
                },
            },
        },
    ],
};
